import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative py-16 px-6 md:px-12 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_web-builder-418/artifacts/ge0fxx2x_Lucentis%20Logo.png"
              alt="LucentisIQ"
              className="h-10 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="font-body text-base text-slate-400 leading-relaxed" data-testid="footer-description">
              Transforming businesses with intelligent solutions and strategic innovation.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg text-white mb-4" data-testid="footer-contact-title">
              Contact Us
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3" data-testid="footer-email">
                <Mail className="w-5 h-5 text-pink-400" />
                <span className="font-body text-sm text-slate-400">info@lucentisiq.com</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg text-white mb-4" data-testid="footer-follow-title">
              Follow Us
            </h3>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:border-pink-500/50 transition-all"
                data-testid="footer-linkedin-link"
              >
                <Linkedin className="w-5 h-5 text-slate-400" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:border-pink-500/50 transition-all"
                data-testid="footer-twitter-link"
              >
                <Twitter className="w-5 h-5 text-slate-400" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:border-pink-500/50 transition-all"
                data-testid="footer-facebook-link"
              >
                <Facebook className="w-5 h-5 text-slate-400" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <p className="text-center font-body text-sm text-slate-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} LucentisIQ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
